<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="error-container">
    <div class="error-content">
      <h1 class="error-code">403</h1>
      <h2 class="error-title">禁止访问</h2>
      <p class="error-description">您没有权限访问此页面，请联系管理员</p>
    </div>
  </div>
</template>

<style scoped>
.error-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: #fff;
}
.error-content {
  text-align: center;
}
.error-code {
  font-size: 120px;
  font-weight: 700;
  margin: 0;
  line-height: 1;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.2);
}
.error-title {
  font-size: 32px;
  margin: 20px 0 10px;
}
.error-description {
  font-size: 18px;
  margin-bottom: 30px;
  opacity: 0.9;
}
</style>